import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import logo from "./medStarLogo-whiteText.svg"
import userIcon from './userIcon.svg'
import auth from "../../../../sitel/demon/services/auth";
import { ArrowUp } from "../../../commons/ui/components";
import ErrorBoundary from "../../../commons/utilities/errorBoundary";
import "./layout.css";

export default function Layout({ homeRelativeUrl, user, siteTitle }) {
    return (
        <>
            <Navbar collapseOnSelect expand="lg" variant="dark" fixed="top" className="bg-medstar-primary">
                <Container>
                    <Navbar.Brand href={homeRelativeUrl}>
                        <img src={logo} height="40px" alt={siteTitle} title={siteTitle} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto">
                            <NavDropdown title={
                                <div className="float-start">
                                    <img src={userIcon} height="20px" alt="icon" className="me-2" />
                                    {user.display_name}
                                </div>
                            }
                                id="collasible-nav-dropdown"
                            >
                                <button className="dropdown-item" onClick={() => auth.localLogout()}>Log Out</button>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <ArrowUp />

            <Container style={{ margin: '6rem auto' }}>
                <ErrorBoundary>
                    <Outlet context={{ user }} />
                </ErrorBoundary>
            </Container>
            <footer className="position-fixed bottom-0 p-2 text-white text-center border-top border-white border-5 shadow-sm d-flex justify-content-end align-items-center app-footer">
                <div>
                    <span>{`©2022 MedStar Health - ${process.env.REACT_APP_NAME[0].toUpperCase() + process.env.REACT_APP_NAME.slice(1).toLowerCase()} v${process.env.REACT_APP_VERSION}`}</span>
                </div>
            </footer>
        </>
    );
}
